import * as types from 'legacy/src/constants/types';

export function saveCourseOutlineConfig(config) {
  return {
    type: types.UNIT_COURSE_OUTLINE_CONFIG,
    payload: config,
  };
}
